// Source: app/scripts/controllers/auction-bidding.js
/**
 * Created by riste_000 on 4/7/2015.
 */


Auction.controller('AuctionBiddingController', [
  '$scope',
  '$modal',
  '$routeParams',
  '$interval',
  'toaster',
  'Auction',
  'crudService',
  'Stomp',
  function ($scope, $modal, $routeParams, $interval, toaster, Auction, crudService, Stomp) {


    //register sevices
    var service = crudService('auction', {
      getBids: {
        method: 'GET',
        url: '/data/rest/auction/:id/lot_bids'
      },
      sendBid: {
        method: 'POST',
        url: '/data/rest/auction/send_bid'
      }
    });

    var lotService = crudService('lots', {
      getProducts: {
        method: 'GET',
        url: '/data/rest/lots/:id/products',
        isArray: true
      }
      // ,
      // getProductsByLots:{
      //   method: 'GET',
      //   url: '/data/rest/lots/products_by_lots',
      //   isArray: true
      // }
    });

    //create modals
    $scope.modalInfo = $modal({
      scope: $scope,
      template: 'forms/modals/lot_products.html',
      show: false
    });

    // get the auction
    $scope.auctionId = $routeParams.auctionId;

    // get the auction
    $scope.auction = Auction.get({
      id: $scope.auctionId
    });

    // the lot intervals for ending auction
    $scope.intervals = {};

        $scope.bids = {};

    function startCounting(lotDto) {
      if (lotDto.lot) {
        lotDto.startTime = (new Date()).getTime();
        lotDto.endTime = lotDto.startTime + lotDto.remainingTime - $scope.loadDelay;

        var prev = $scope.intervals[lotDto.lot.id];
        if (prev) {
          $interval.cancel(prev);
        }
        if (lotDto.remainingTime / 1000 > 0) {
          $scope.intervals[lotDto.lot.id] = $interval(function () {
            var now = (new Date().getTime());
            var timeLeft = Math.floor((lotDto.endTime - now));
            /**
             * check the change in the remaining time. If it is greater than 4 seconds, there is some
             * strange client time change, and thus reload the page.
             */
            if (Math.abs(timeLeft - lotDto.remainingTime) > 4000) {
              load();
            }
            /**
             * If the page is opened more than 10 minutes, reload the bids in order to sync the clock
             */
            if (now - lotDto.startTime > 600000) {
              load();
            }
            lotDto.remainingTime = Math.floor((lotDto.endTime - (new Date().getTime())));
          }, 1000, lotDto.remainingTime / 1000);
        }
      }
    }

    function registerLot(lot, lotId) {
      // ignoring private angular fields in the iteraton
      if (typeof lotId === 'string' && lotId.indexOf('$') === 0)
        return;

      startCounting(lot);
      // index bids
      angular.forEach(lot.bids, function (bid) {
        $scope.bids[bid.id] = bid;
      });
      Stomp("/topic/bid/", lotId, onNewBid, $scope);
    }


    function load() {
      var start = (new Date()).getTime();
      service.getBids({
        id: $scope.auctionId
      }, function (data) {
        $scope.lotDtos = data;
        var end = (new Date()).getTime();
        $scope.loadDelay = end - start;
        angular.forEach($scope.lotDtos, registerLot);
      });
    }

    load();


    function onNewBid(bid) {
      $scope.$apply(function () {
        var lastBid = $scope.bids[bid.id];
        var lotDto = $scope.lotDtos[bid.lotId];
        lotDto.remainingTime = bid.remainingTime;
        startCounting(lotDto);
        if (lastBid) {
          lastBid.amount = bid.amount;
        } else {
          $scope.bids[bid.id] = bid;
          lotDto.bids.push(bid);
        }
        if (lotDto.highestBid < bid.amount) {
          lotDto.highestBid = bid.amount;
        }
      });
    }


    $scope.placeBid = function (bid, lotDto) {
      bid.lot = lotDto.lot;
      bid.auction = lotDto.lot.auction;
      service.sendBid({
        id: bid.lot.id,
        bid: bid
      }, function (bidDto) {
        delete bid.offeredAmount;
        var lotDto = $scope.lotDtos[bid.lot.id];
        var lastBid = $scope.bids[bidDto.id];
        lotDto.remainingTime = bidDto.remainingTime;
        lotDto.highestBid = bidDto.amount;
        startCounting(lotDto);

        if (!lastBid) {
          $scope.bids[bidDto.id] = bidDto;
          lotDto.bids = lotDto.bids || [];
          lotDto.bids.push(bidDto);
        } else {
          lastBid.username = bidDto.username;
          lastBid.amount = bidDto.amount;
        }
      });
    };

    $scope.raiseBidMinimum = function (lotDto) {
      lotDto.bid = lotDto.bid || {};
      lotDto.bid.offeredAmount = $scope.minAllowedBid(lotDto);
    };

    $scope.hasMaximumIncrement = function (lotDto) {
      return !!(lotDto && lotDto.lot && lotDto.lot.maximumIncrementType
        && lotDto.lot.maximumIncrementValue != null && lotDto.lot.maximumIncrementValue !== '');
    };

    $scope.minIncrementStep = function (lotDto) {
      var highest = Number(lotDto.highestBid);
      var minValue = Number(lotDto.lot.minimumIncrementAmount);
      if (lotDto.lot.maximumIncrementType === 'PERCENT') {
        return Math.round(highest * minValue) / 100;
      }
      return minValue;
    };

    $scope.minAllowedBid = function (lotDto) {
      return Number(lotDto.highestBid) + $scope.minIncrementStep(lotDto);
    };

    $scope.maxIncrementStep = function (lotDto) {
      if (!$scope.hasMaximumIncrement(lotDto)) {
        return null;
      }
      var highest = Number(lotDto.highestBid);
      var maxStep;
      if (lotDto.lot.maximumIncrementType === 'PERCENT') {
        maxStep = Math.round(highest * Number(lotDto.lot.maximumIncrementValue)) / 100;
      } else {
        maxStep = Number(lotDto.lot.maximumIncrementValue);
      }
      var minStep = $scope.minIncrementStep(lotDto);
      if (maxStep < minStep) {
        maxStep = minStep;
      }
      return maxStep;
    };

    $scope.maxAllowedBid = function (lotDto) {
      var maxStep = $scope.maxIncrementStep(lotDto);
      return maxStep == null ? null : Number(lotDto.highestBid) + maxStep;
    };

    $scope.isBidTooLow = function (lotDto) {
      return !!(lotDto.bid && lotDto.bid.offeredAmount != null
        && $scope.minAllowedBid(lotDto) > Number(lotDto.bid.offeredAmount));
    };

    $scope.isBidTooHigh = function (lotDto) {
      var max = $scope.maxAllowedBid(lotDto);
      return max != null && lotDto.bid && lotDto.bid.offeredAmount != null
        && Number(lotDto.bid.offeredAmount) > max;
    };

    $scope.isBidInvalid = function (lotDto) {
      return !lotDto.bid || !lotDto.bid.offeredAmount
        || $scope.isBidTooLow(lotDto) || $scope.isBidTooHigh(lotDto);
    };

    $scope.lotInfo = function (lot) {
      $scope.products = lotService.getProducts({
        id: lot.id
      });
      $scope.modalInfo.$promise.then($scope.modalInfo.show);
    };


  }]);
